/** Resolve old and new settings without guessing registered providers or dropping unknown ids. */
export function normalizeWebSearchRouting(config) {
    const defaultProvider = config.defaultSearchProvider?.trim() || 'deepseek-official';
    const legacy = config.searchProvider === undefined;
    return {
        primaryProvider: legacy
            ? config.searchMode === 'fixed' ? defaultProvider : 'auto'
            : config.searchProvider?.trim() || 'auto',
        defaultProvider,
        legacy,
    };
}
//# sourceMappingURL=search-routing-policy.js.map